import { GetUserSettings, IPostUserPayload, PatchUserPayload, WorkingHoursPutPayload } from "app/models/user"
import { Params } from "app/redux/users/users.reducer"
import { AxiosPromise } from "axios"
import WorkingHour from "app/models/workingHour"
import { usersApi } from "./api"

export const getUsersById = (id: string): AxiosPromise => usersApi(`/users/${id}`)

export const getUsers = (params?: Params): AxiosPromise =>
  usersApi("/users", {
    method: "GET",
    params,
  })

export const patchUsers = (data: PatchUserPayload): AxiosPromise =>
  usersApi(`/users/${data.id}`, {
    data,
    method: "PATCH",
  })

export const deleteUsersById = (id: string): AxiosPromise =>
  usersApi(`/users/${id}`, {
    method: "DELETE",
  })

export const postUsers = (data: IPostUserPayload): AxiosPromise => usersApi("/users", { method: "POST", data })

export const putUserWorkingHoursById = (payload: WorkingHoursPutPayload): AxiosPromise => {
  const { userId, data } = payload
  return usersApi(`/users/${userId}/preferable_working_hours`, {
    method: "PUT",
    data,
  })
}

export const getPreferedHours = (id: string): AxiosPromise =>
  usersApi(`/users/${id}/preferable_working_hours`, { method: "GET" })

export const deleteUserWorkingHoursById = (userId: string, data: WorkingHour): AxiosPromise => {
  const { id: deleteId } = data
  return usersApi(`/users/${userId}/preferable_working_hours/${deleteId}`, {
    method: "DELETE",
  })
}

export const putUserSettings = (data: GetUserSettings): AxiosPromise =>
  usersApi("/users/settings", {
    data,
    method: "PUT",
  })
